export type TicketDetailViewPref = 'tech' | 'full' | undefined;

export function prefersTechTicketView(
  role: string | undefined,
  pref: TicketDetailViewPref,
): boolean {
  if (pref === 'tech') return true;
  if (pref === 'full') return false;
  return role === 'technician';
}

export function ticketDetailPath(
  id: string,
  opts?: { role?: string; pref?: TicketDetailViewPref },
): string {
  return prefersTechTicketView(opts?.role, opts?.pref) ? `/tech/tickets/${id}` : `/tickets/${id}`;
}
